import { createSelector } from '@ngrx/store';
import {
  configurationDocumentKey,
  configurationSubmissionKey,
} from '../constants/configurations.constant';
import { DocumentTypeState, SubmissionTypeState } from '../types';

/**
 * @DOCUMENT TYPE SELECTORS
 */
export const loadDocumentTypes = createSelector(
  (state: any) => state[configurationDocumentKey],
  (configuration: DocumentTypeState) => configuration?.documentTypes,
);

export const loadAttributes = createSelector(
  (state: any) => state[configurationDocumentKey],
  (configuration: DocumentTypeState) => configuration?.attributes,
);

export const loadDocumentTypesTableData = createSelector(
  (state: any) => state[configurationDocumentKey],
  (configuration: DocumentTypeState) => configuration?.documentTypesTableData,
);
/**
 * @DOCUMENT TYPE SELECTORS END
 */

/**
 * @SUBMISSION TYPE SELECTORS
 */
export const loadSubmissions = createSelector(
  (state: any) => state[configurationSubmissionKey],
  (configuration: SubmissionTypeState) => configuration?.submissions,
);

export const loadSubmissionsTableData = createSelector(
  (state: any) => state[configurationSubmissionKey],
  (configuration: SubmissionTypeState) => configuration?.submissionsTableData,
);

export const loadSubmissionDocument = createSelector(
  (state: any) => state[configurationSubmissionKey],
  (configuration: SubmissionTypeState) => configuration?.submissionDocument,
);

export const loadSubmissionDocumentTypes = createSelector(
  (state: any) => state[configurationSubmissionKey],
  (configuration: SubmissionTypeState) =>
    configuration?.submissions.documentTypes,
);

/**
 * @SUBMISSION TYPE SELECTORS END
 */
